import { ReactComponent as LogoDefault } from "../assets/gestalt-logo.svg";
import { ReactComponent as LogoWhite } from "../assets/gestalt-logo-white.svg";

export default function GestaltLogo({
  variant = "default",
  className = "h-[63px] max-w-none",
}) {
  const Logo = variant === "white" ? LogoWhite : LogoDefault;

  return (
    <Logo
      className={`gestalt-logo logo-mark__surface block w-auto select-none ${className}`}
      aria-label="Gestalt"
      role="img"
    />
  );
}
